import React from 'react'
import styled from 'styled-components'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
position: relative;
z-index: 1;
align-items: center;
@media (max-width: 960px) {
    padding: 0px;
}
`

const Toast = styled.div`
  position: fixed;
  top: 80px;
  right: 30px;
  background: ${({ severity }) => severity === 'success' ? '#1a1a2e' : '#2d1b1b'};
  color: white;
  padding: 20px 24px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 300px;
  z-index: 9999;
  animation: slideIn 0.3s ease-out;
  border: 1px solid ${({ severity }) => severity === 'success' ? '#4caf50' : '#f44336'};

  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    right: 20px;
    left: 20px;
    min-width: auto;
  }
`

const ToastIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${({ severity }) => severity === 'success' ? '#4caf50' : '#f44336'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  &::after {
    content: '${({ severity }) => severity === 'success' ? '✓' : '✕'}';
    color: white;
    font-size: 14px;
    font-weight: bold;
  }
`

const ToastContent = styled.div`
  flex: 1;
`

const ToastMessage = styled.div`
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
`

const ToastProgress = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: ${({ severity }) => severity === 'success' ? '#4caf50' : '#f44336'};
  border-radius: 0 0 12px 12px;
  animation: progress 6s linear forwards;

  @keyframes progress {
    from {
      width: 100%;
    }
    to {
      width: 0%;
    }
  }
`

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;

  &:hover {
    color: white;
  }
`

const Wrapper = styled.div`
position: relative;
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: column;
width: 100%;
max-width: 1350px;
padding: 0px 0px 80px 0px;
gap: 12px;
@media (max-width: 960px) {
    flex-direction: column;
}
`

const Title = styled.div`
font-size: 42px;
text-align: center;
font-weight: 600;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
      margin-top: 12px;
      font-size: 32px;
  }
`;

const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;


const ContactForm = styled.form`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.card};
  padding: 32px;
  border-radius: 16px;
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  margin-top: 28px;
  gap: 12px;
`

const ContactTitle = styled.div`
  font-size: 24px;
  margin-bottom: 6px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
`

const ContactInput = styled.input`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
`

const ContactInputMessage = styled.textarea`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
`

const ContactButton = styled.input`
  width: 100%;
  text-decoration: none;
  text-align: center;
  background: hsla(271, 100%, 50%, 1);
  background: linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
  background: -moz-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
  background: -webkit-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
  padding: 13px 16px;
  margin-top: 2px;
  border-radius: 12px;
  border: none;
  color: ${({ theme }) => theme.text_primary};
  font-size: 18px;
  font-weight: 600;
`



const Contact = () => {

  //hooks
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [isSending, setIsSending] = React.useState(false);
  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSending) return;
    setIsSending(true);
    emailjs
      .sendForm('service_vkdtxz7', 'template_ckbsxrg', form.current, 'aRXLZrf9d_FXPV9cQ')
      .then(() => {
        setSnackbar({ open: true, message: 'Message sent', severity: 'success' });
        form.current.reset();
        setTimeout(() => {
          setSnackbar((prev) => ({ ...prev, open: false }));
        }, 6000);
      })
      .catch((error) => {
        console.log(error);
        const errorMessage = error?.text || error?.message || 'Failed to send message';
        setSnackbar({ open: true, message: errorMessage, severity: 'error' });
        setTimeout(() => {
          setSnackbar((prev) => ({ ...prev, open: false }));
        }, 6000);
      })
      .finally(() => {
        setIsSending(false);
      });
  }



  return (
    <Container id='contacts'>
      <Wrapper>
        <Title>Contact</Title>
        <Desc>Feel free to reach out to me for any questions or opportunities!</Desc>
        <ContactForm ref={form} onSubmit={handleSubmit}>
          <ContactTitle>Email Me </ContactTitle>
          <ContactInput placeholder="Your Email" name="from_email" type="email" required />
          <ContactInput placeholder="Your Name" name="from_name" required />
          <ContactInput placeholder="Subject" name="subject" required />
          <ContactInputMessage placeholder="Message" rows="4" name="message" required />
          <ContactButton type="submit" value={isSending ? 'Sending...' : 'Send'} disabled={isSending} />
        </ContactForm>
        {snackbar.open && (
          <Toast severity={snackbar.severity}>
            <ToastIcon severity={snackbar.severity} />
            <ToastContent>
              <ToastMessage>
                {snackbar.message} {snackbar.severity === 'success' && ''}
              </ToastMessage>
            </ToastContent>
            <CloseButton onClick={() => setSnackbar((prev) => ({ ...prev, open: false }))}>
              ✕
            </CloseButton>
            <ToastProgress severity={snackbar.severity} />
          </Toast>
        )}
      </Wrapper>
    </Container>
  )
}

export default Contact
